import * as $ from 'jquery';
import {getCurrentLanguage} from 'Core/Languages';
import {CartService} from 'Components/Cart/CartService';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {onClick, onChange} from 'Core/Events';
import {PlannerSubProcessCommon} from "Components/Planner/PlannerSubProcessCommon";

export class ServiceTransferDataFromPlannerToCart extends PlannerSubProcessCommon {

    private static planerData;

    @onClick(PlannerSelectors.MODAL.FORCE_ADD_TO_CART, ServiceTransferDataFromPlannerToCart.loadAndDisplayAgreeModal)
    @onChange(PlannerSelectors.MODAL.AGREE.CHECKBOX, ServiceTransferDataFromPlannerToCart.toggleAgreeButtons)
    @onClick(PlannerSelectors.MODAL.AGREE.BUTTONS, ServiceTransferDataFromPlannerToCart.initProductTransmission)

    /**
     * Inicjacja procesu przeniesienia danych
     */
    public initTransfer(basketContent: string) {
        ServiceTransferDataFromPlannerToCart.planerData = JSON.parse(basketContent);
        ServiceTransferDataFromPlannerToCart.setSpinnerOnModal();
        ServiceTransferDataFromPlannerToCart.modalOn()

        ServiceTransferDataFromPlannerToCart.checkProductsAvailability()
            .done((response) => {
                ServiceTransferDataFromPlannerToCart.setContentOnModal(response);
            });
    }

    /**
     * Wczytuje iładuje modal ze zgodami
     */
    private static loadAndDisplayAgreeModal() {
        ServiceTransferDataFromPlannerToCart.setSpinnerOnModal();
        ServiceTransferDataFromPlannerToCart.loadAgreeModal()
            .done((response) => {
                ServiceTransferDataFromPlannerToCart.setContentOnModal(response);
            });
    }

    /**
     * Proces przekazania danych z planera do koszyka
     */
    private static initProductTransmission(e) {
        let btn = $(e.target);
        let mode = btn.data('addMode');
        ServiceTransferDataFromPlannerToCart.setSpinnerOnModal();

        if (mode == 'delete-and-add') {
            ServiceTransferDataFromPlannerToCart.clearBaskets()
        }

        ServiceTransferDataFromPlannerToCart.initAddToBasket()
            .then((response) => {
                ServiceTransferDataFromPlannerToCart.setContentOnModal(response);
            })
            .then(() => ServiceTransferDataFromPlannerToCart.getBasketCounts())
            .then(data => ServiceTransferDataFromPlannerToCart.setBasketCounters(data)
            );
    }

    /**
     * Czyszczenie koszyków
     */
    private static async clearBaskets() {
        let promises = [];
        promises.push(CartService.clear(getCurrentLanguage));
        promises.push(CartService.clear_offer(getCurrentLanguage));
        return Promise.all(promises);
    }

    /**
     * Pobiera stan liczników z obu koszyków
     */
    private static getBasketCounts() {
        return CartService.getAllBskCount();
    }

    /**
     * Zwraca modal z informacją o problemach lub zgodami
     */
    private static checkProductsAvailability() {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}check_products_availability/`,
            method: 'POST',
            data: {
                plannerProducts: ServiceTransferDataFromPlannerToCart.planerData
            },
            dataType: 'html',
        })
    }

    /**
     * Przekazanie wszystkich produktów z planera do koszyka
     */
    private static async initAddToBasket() {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}init_add_to_basket/`,
            method: 'POST',
            data: {
                plannerProducts: ServiceTransferDataFromPlannerToCart.planerData
            },
            dataType: 'html',
        })
    }

    /**
     * Wczytuje modal ze zgodami
     */
    private static loadAgreeModal() {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}load_modal_agree/`,
            method: 'GET',
            dataType: 'html',
        })
    }


    private static async prepareAfterAddModal(data) {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}get_modal_summary/`,
            method: 'POST',
            data: {
                data: data
            },
            dataType: 'html',
        })
    }

    /**
     * Ustawia liczniki na obo koszykach
     */
    private static setBasketCounters(data) {
        if (data.count_bsk !== undefined && data.count_bsk > 0) {
            $(PlannerSelectors.CART_ICON.CART_COUNT).show().html(data.count_bsk.toString())
        } else {
            $(PlannerSelectors.CART_ICON.CART_COUNT).hide().html("0")
        }
        if (data.count_bsk_offer !== undefined && data.count_bsk_offer > 0) {
            $(PlannerSelectors.CART_ICON.OFFER_COUNT).show().html(data.count_bsk_offer.toString())
        } else {
            $(PlannerSelectors.CART_ICON.OFFER_COUNT).hide().html("0")
        }
    }

    /**
     * Przełączanie blokady buttonów z modala zgod
     */
    private static toggleAgreeButtons(e) {
        if ($(e.target).prop("checked") == true) {
            $(PlannerSelectors.MODAL.AGREE.BUTTONS).prop("disabled", false);
        } else {
            $(PlannerSelectors.MODAL.AGREE.BUTTONS).prop("disabled", true);
        }
    }

}import * as $ from 'jquery';
import {getCurrentLanguage} from 'Core/Languages';
import {CartService} from 'Components/Cart/CartService';
import {PlannerSelectors} from 'Components/Planner/PlannerSelectors'
import {onClick, onChange} from 'Core/Events';
import {PlannerSubProcessCommon} from "Components/Planner/PlannerSubProcessCommon";

export class ServiceTransferDataFromPlannerToCart extends PlannerSubProcessCommon {

    private static planerData;

    @onClick(PlannerSelectors.MODAL.FORCE_ADD_TO_CART, ServiceTransferDataFromPlannerToCart.loadAndDisplayAgreeModal)
    @onChange(PlannerSelectors.MODAL.AGREE.CHECKBOX, ServiceTransferDataFromPlannerToCart.toggleAgreeButtons)
    @onClick(PlannerSelectors.MODAL.AGREE.BUTTONS, ServiceTransferDataFromPlannerToCart.initProductTransmission)

    /**
     * Inicjacja procesu przeniesienia danych
     */
    public initTransfer(basketContent: string) {
        ServiceTransferDataFromPlannerToCart.planerData = JSON.parse(basketContent);
        ServiceTransferDataFromPlannerToCart.setSpinnerOnModal();
        ServiceTransferDataFromPlannerToCart.modalOn()

        ServiceTransferDataFromPlannerToCart.checkProductsAvailability()
            .done((response) => {
                ServiceTransferDataFromPlannerToCart.setContentOnModal(response);
            });
    }

    /**
     * Wczytuje iładuje modal ze zgodami
     */
    private static loadAndDisplayAgreeModal() {
        ServiceTransferDataFromPlannerToCart.setSpinnerOnModal();
        ServiceTransferDataFromPlannerToCart.loadAgreeModal()
            .done((response) => {
                ServiceTransferDataFromPlannerToCart.setContentOnModal(response);
            });
    }

    /**
     * Proces przekazania danych z planera do koszyka
     */
    private static initProductTransmission(e) {
        let btn = $(e.target);
        let mode = btn.data('addMode');
        ServiceTransferDataFromPlannerToCart.setSpinnerOnModal();

        if (mode == 'delete-and-add') {
            ServiceTransferDataFromPlannerToCart.clearBaskets()
        }

        ServiceTransferDataFromPlannerToCart.initAddToBasket()
            .then((response) => {
                ServiceTransferDataFromPlannerToCart.setContentOnModal(response);
            })
            .then(() => ServiceTransferDataFromPlannerToCart.getBasketCounts())
            .then(data => ServiceTransferDataFromPlannerToCart.setBasketCounters(data)
            );
    }

    /**
     * Czyszczenie koszyków
     */
    private static async clearBaskets() {
        let promises = [];
        promises.push(CartService.clear(getCurrentLanguage));
        promises.push(CartService.clear_offer(getCurrentLanguage));
        return Promise.all(promises);
    }

    /**
     * Pobiera stan liczników z obu koszyków
     */
    private static getBasketCounts() {
        return CartService.getAllBskCount();
    }

    /**
     * Zwraca modal z informacją o problemach lub zgodami
     */
    private static checkProductsAvailability() {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}check_products_availability/`,
            method: 'POST',
            data: {
                plannerProducts: ServiceTransferDataFromPlannerToCart.planerData
            },
            dataType: 'html',
        })
    }

    /**
     * Przekazanie wszystkich produktów z planera do koszyka
     */
    private static async initAddToBasket() {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}init_add_to_basket/`,
            method: 'POST',
            data: {
                plannerProducts: ServiceTransferDataFromPlannerToCart.planerData
            },
            dataType: 'html',
        })
    }

    /**
     * Wczytuje modal ze zgodami
     */
    private static loadAgreeModal() {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}load_modal_agree/`,
            method: 'GET',
            dataType: 'html',
        })
    }


    private static async prepareAfterAddModal(data) {
        return $.ajax({
            url: `${ServiceTransferDataFromPlannerToCart.ajaxUrl}get_modal_summary/`,
            method: 'POST',
            data: {
                data: data
            },
            dataType: 'html',
        })
    }

    /**
     * Ustawia liczniki na obo koszykach
     */
    private static setBasketCounters(data) {
        if (data.count_bsk !== undefined && data.count_bsk > 0) {
            $(PlannerSelectors.CART_ICON.CART_COUNT).show().html(data.count_bsk.toString())
        } else {
            $(PlannerSelectors.CART_ICON.CART_COUNT).hide().html("0")
        }
        if (data.count_bsk_offer !== undefined && data.count_bsk_offer > 0) {
            $(PlannerSelectors.CART_ICON.OFFER_COUNT).show().html(data.count_bsk_offer.toString())
        } else {
            $(PlannerSelectors.CART_ICON.OFFER_COUNT).hide().html("0")
        }
    }

    /**
     * Przełączanie blokady buttonów z modala zgod
     */
    private static toggleAgreeButtons(e) {
        if ($(e.target).prop("checked") == true) {
            $(PlannerSelectors.MODAL.AGREE.BUTTONS).prop("disabled", false);
        } else {
            $(PlannerSelectors.MODAL.AGREE.BUTTONS).prop("disabled", true);
        }
    }

}